module.exports = __webpack_public_path__ + "static/media/Hangar_Door_02.63dd3c8f.jpg";